<template lang="pug">
  .b-indicator(:class="{ saved: !loading }")
    Icon(:name="loading ? 'loader' : 'complete'")
    | {{ loading ? 'Сохранение...' : 'Сохранено' }}
</template>

<script>
export default {
  name: 'BaseRequestIndicator',
  props: {
    loading: Boolean,
  },
};
</script>

<style scoped lang="scss">
  .indicator {
    opacity: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #788CA1;

    &.saved {
      transition: opacity 1s linear 3s;
      opacity: 0;
    }

    svg::v-deep {
      width: 20px;
      height: 20px;
    }
  }
</style>
